<template>
    <AdminPageInner v-if="loaded" :breadcrumbs="breadcrumbs">
        <template #heading>{{ assignmentLabel }}</template>
        <PaginationWrapper ref="pagination" :rows="assignments.data" :constraints="constraints" :meta="meta">
            <DataComponent
                class="w-full mt-6"
                :data="assignments.data"
                :initialSort="initialSort"
                @sort="onSort">
                
                <DataField name="name">
                    <template v-slot="{row, sortable}">
                        <AppLink
                            v-if="row.user_can.view"
                            :to="{ name: assignmentEditRoute, params: {courseId: row.course_id, assignmentId: row.id}}">
                            {{ row.student.firstname + ' ' + row.student.lastname }}
                        </AppLink>
                        <span v-else>{{ row.student.firstname + ' ' + row.student.lastname }}</span>
                    </template>
                </DataField>

                <DataField name="title">
                    <template v-slot="{row, sortable}">
                        {{ row.title }}
                    </template>
                </DataField>

                <DataField name="status">
                    <template v-slot="{row, sortable}">
                        <span v-if="row.status == AssignmentStatus.Pending ">Pending</span>
                        <span v-else-if="row.status == AssignmentStatus.Accepted ">Accepted</span>
                        <span v-else-if="row.status == AssignmentStatus.Rejected ">Rejected</span>
                        <span v-else-if="row.status == AssignmentStatus.Cancelled ">Cancelled</span>
                    </template>
                </DataField>
                
                <DataField name="actions" :sortable="false" :showLabel="false" :showResponsiveLabel="false">
                    <template v-slot="{row}">
                        <div class="flex justify-around md:justify-end items-center">
                            <router-link
                                v-if="row.user_can.update"
                                class="text-indigo-600 hover:text-indigo-900 mr-4"
                                :to="{ name: assignmentEditRoute, params: {courseId: row.course_id, assignmentId: row.id}}">
                                Edit
                            </router-link>
                        </div>
                    </template>
                </DataField>
            </DataComponent>
        </PaginationWrapper>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import {AssignmentStatus} from "@/Lib/Enums";
import AdminPageInner from "@/Components/Layout/AdminPageInner.vue";
import PaginationWrapper from "@/Components/Layout/PaginationWrapper.vue";
import PaginationPage from "@/Mixins/PaginationPage";
import {DataComponent, DataField} from "@/Components/DataComponent";
import dayjs from "dayjs";
import AppLink from "@/Components/AppLink";

export default {

    name: "AssignmentIndexPage",

    mixins: [PaginationPage],

    methods: {
        setData(data) {
            this.course = data.course;
            this.assignments = data.assignments;
            this.loaded = true;
        },
    },

    data() {
        return {
            AssignmentStatus,
            statusFilters: [
                {label: "All", value: null},
                {label: "Pending", value: AssignmentStatus.Pending},
                {label: "Accepted", value: AssignmentStatus.Accepted},
                {label: "Rejected", value: AssignmentStatus.Rejected},
            ],
            editing: [],
            processing: [],
            assignments: {},
            course: {}
        };
    },

    components: {
        AdminPageInner,
        PaginationWrapper,
        DataComponent,
        DataField,
        AppLink
    },

    computed: {
        breadcrumbs() {
            return [
                {
                    label: 'Admin', to: {name: 'admin'}
                },
                {
                    label: 'Courses', to: {name: 'admin.courses.index'}
                },
                {
                    label: `${this.course.title || 'Course'}`,
                    to: {name: 'admin.courses.show', params: {courseId: this.$route.params.courseId}}
                },
                {
                    label: this.assignmentLabel, to: {name: this.$route.name, params: this.$route.params}
                },
            ];
        },
        assignmentLabel() {
            return !this.$route.meta.isCertificate ? 'Assignments' : 'Certificates';
        },
        assignmentType() {
            return !this.$route.meta.isCertificate ? 1 : 2;
        },
        assignmentEditRoute() {
            return !this.$route.meta.isCertificate ? 'admin.assignments.edit' : 'admin.certificates.edit';
        }
    },

    async beforeRouteEnter(to, from, next) {
        const data = await fetchData(to);
        next(vm => vm.setData(data));
    },

    async beforeRouteUpdate(to, from) {
        const data = await fetchData(to);
        this.setData(data);
    },
};

const fetchData = async (to) => {
    let params =  to.query;
        params.course_id = to.params.courseId;
        params.type = !to.meta.isCertificate ? 1 : 2;

    const data = await Promise.all([
        axios.get(route('api.courses.show', to.params.courseId), {params: to.query}),
        axios.get(route('api.course.assignments'), {
            params: params
        })
    ])

    return {
        course: data[0].data,
        assignments: data[1].data
    };
}

</script>
